import qrcode from 'qrcode-generator';
import { useMemo } from 'react';

/**
 * A QR code drawn as SVG paths (no inline HTML or data URLs, fine for the CSP). Used for the
 * authenticator setup link (otpauth://) of the admin MFA.
 */
export function QrCode({
  value,
  label,
  size = 208,
}: {
  value: string;
  label: string;
  size?: number;
}) {
  const { count, path } = useMemo(() => {
    const qr = qrcode(0, 'M');
    qr.addData(value);
    qr.make();
    const n = qr.getModuleCount();
    let d = '';
    for (let row = 0; row < n; row += 1)
      for (let col = 0; col < n; col += 1) if (qr.isDark(row, col)) d += `M${col} ${row}h1v1h-1z`;
    return { count: n, path: d };
  }, [value]);
  const quiet = 4;
  const box = count + quiet * 2;
  return (
    <svg
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`${-quiet} ${-quiet} ${box} ${box}`}
      shapeRendering="crispEdges"
    >
      <rect x={-quiet} y={-quiet} width={box} height={box} fill="#fff" />
      <path d={path} fill="#000" />
    </svg>
  );
}
